import { useGlobalStore } from "@/store/GlobalStore";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  PictureNormalVipWrapper,
  PictureNormalVipRechargeCard,
  RechargePerMonth,
} from "./atom";
import {
  OrderPaymentTypeCode,
  PaymentPurposeCode,
  PaymentTypeCode,
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
} from "project-config/constants";
import { useEffect, useState } from "react";
import CheckIcon from "@/assets/icons/topup/check";
import { CommonCardListWrapper, CommonUpperPart } from "../../atom";
import { usePictureTopUpStore } from "../../store";
import {
  NormalVipRechargeRules,
  VipRechargeInfo,
} from "../../constants/picture-vip-info";
import { PaymentWay } from "../payment-way";
import { Checkbox } from "@renderbus/ui";
import ActivityRule from "@/components/top-up/components/activity-rule";
import { ExtraWelfareType } from "../../help/tips";
import { ExtraWelfareTipType } from "../../types";

export function PictureNormalVipRecharge() {
  const { t } = useTranslation("topup");
  const { currencySymbol } = useGlobalStore();
  const [openNormalVipRuleDrawer, setOpenNormalVipRuleDrawer] = useState(false);
  const [checkedCard, setCheckedCard] = useState(VipRechargeInfo[0]);
  const [searchParams] = useSearchParams();
  const card = searchParams.get("type");
  const [checkProtocol, setCheckProtocol] = useState(false);
  const { setter, addMemberRecharge } = usePictureTopUpStore();
  const paying = usePictureTopUpStore((state) => state.paying);
  const extraTip = [
    {
      type: ExtraWelfareType.VIP,
      content: [checkedCard.vipMonth],
      pre: t("activity_member_free_member_vip"),
      contentSuf: t("activity_member_free_member_month"),
    },
  ] as ExtraWelfareTipType[];

  const getQrCodeLink = () =>
    `&${QRCODE_QUERY_MAP.orderType}=${OrderPaymentTypeCode.MemberOrder}&${
      QRCODE_QUERY_MAP.type
    }=${checkedCard?.type}&${QRCODE_QUERY_MAP.mount}=${1}&${
      QRCODE_QUERY_MAP.rechargeGoal
    }=${PaymentPurposeCode.OrdinaryRecharge}`;
  const onClickCantScanCode = async () => {
    const params = {
      payMethod: PaymentTypeCode.Alipay,
      mount: 1,
      type: checkedCard?.type,
      rechargeGoal: PaymentPurposeCode.OrdinaryRecharge,
      rechargeChannels: rechargeChannelsCode.Web,
    };
    await addMemberRecharge(params);
  };

  useEffect(() => {
    if (card) {
      const info =
        VipRechargeInfo.find((i) => i.type === +card) || VipRechargeInfo[0];
      setCheckedCard(info);
      setter({
        amount: info.price,
      });
    } else {
      setCheckedCard(VipRechargeInfo[0]);
      setter({
        amount: VipRechargeInfo[0].price,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PictureNormalVipWrapper>
      <ActivityRule
        ruleList={NormalVipRechargeRules}
        openRuleDrawer={openNormalVipRuleDrawer}
        changeDrawer={(val) => {
          setOpenNormalVipRuleDrawer(val);
        }}
      />
      <CommonUpperPart>
        <CommonCardListWrapper>
          {VipRechargeInfo.map((item) => {
            return (
              <PictureNormalVipRechargeCard
                key={item.type}
                onClick={() => {
                  setCheckedCard(item);
                  setter({
                    amount: item.price,
                  });
                }}
                isActive={checkedCard?.type === item.type}
                padding={"14px 12px 16px 12px"}
                gap={"0px"}
              >
                <div className="recharge-vip">
                  {item.vipMonth}
                  {t("activity_member_free_member_month")}
                </div>
                <div className="recharge-price">
                  <div>
                    <span className="unit">{currencySymbol}</span>
                    <span className="price">{item.price}</span>
                    <span className="original-price">
                      {currencySymbol}
                      {item.originalPrice}
                    </span>
                  </div>
                  {checkedCard?.type === item.type && <CheckIcon />}
                </div>
                {item.vipMonth !== 1 && (
                  <RechargePerMonth>
                    {t("picture_vip_save", {
                      amount: Number(item.originalPrice - item.price),
                    })}
                  </RechargePerMonth>
                )}
              </PictureNormalVipRechargeCard>
            );
          })}
        </CommonCardListWrapper>
      </CommonUpperPart>
      <PaymentWay
        disabledProtocol={!checkProtocol}
        qrcodeLink={getQrCodeLink()}
        onClickCantScanCode={onClickCantScanCode}
        paying={paying}
        extraTip={extraTip}
        extra={
          <Checkbox
            value={checkProtocol}
            onChange={(e) => setCheckProtocol(e.target.checked)}
            className="picture-vip-protocols"
          >
            <span>{t("picture_vip_protocol")}</span>
            <a
              href={
                "https://www.renderbus.com/support-new/xrxz/fwtkyts/xgthyxy/"
              }
              target={"_blank"}
              rel="noreferrer"
            >
              {t("picture_vip_protocol_link")}
            </a>
          </Checkbox>
        }
      />
    </PictureNormalVipWrapper>
  );
}
